


































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import AnnouncementPanelContent from '@/components/atoms/AnnouncementPanelContent.vue';
import AnnouncementLinks from '@/components/molecules/AnnouncementLinks.vue';
import { i18n } from '@/plugins/i18n/i18n';
import {
  UserAnnouncement,
  UpdateUserAnnouncementQueryParam,
} from '@/types/type';
import { PAGE_PATH_BY_NAME } from '@/utils/consts';

export interface CaptionCollection {
  priorityTagHigh: string;
  priorityTagMedium: string;
  priorityTagLow: string;
  displayPeriodLabel: string;
  contentLabel: string;
  updateDateLabel: string;
  urlLabel: string;
  close: string;
}

@Component({
  components: { AnnouncementLinks, AnnouncementPanelContent },
})
export default class PortalAnnouncementsPanel extends Vue {
  private title: string = i18n.tc('portal.announcement');
  private noAnnouncement: string = i18n.tc('announcement.noAnnouncement');
  private seeAll: string = i18n.tc('portal.seeAll');

  @Prop()
  private userAnnouncements!: UserAnnouncement[];

  private announcementListPath: String = PAGE_PATH_BY_NAME.announcementList;

  private get captionCollection(): CaptionCollection {
    // For link
    const priorityTagHigh: string = i18n.tc('announcement.highPriorityFlg');
    const priorityTagMedium: string = i18n.tc('announcement.mediumPriorityFlg');
    const priorityTagLow: string = i18n.tc('announcement.lowPriorityFlg');

    // For dialog
    const displayPeriodLabel: string = i18n.tc(
      'announcement.displayPeriodLabel'
    );
    const contentLabel: string = i18n.tc('announcement.contentLabel');
    const updateDateLabel: string = i18n.tc('announcement.updateDateLabel');
    const urlLabel: string = i18n.tc('announcement.urlLabel');
    const close: string = i18n.tc('common.close');

    const captionCollection: CaptionCollection = {
      priorityTagHigh,
      priorityTagMedium,
      priorityTagLow,
      displayPeriodLabel,
      contentLabel,
      updateDateLabel,
      urlLabel,
      close,
    };
    return captionCollection;
  }

  @Emit('button-link-opened')
  private buttonLinkOpened(
    param: UpdateUserAnnouncementQueryParam
  ): UpdateUserAnnouncementQueryParam {
    return param;
  }
}
